var exports =
  [
    {id: 'BELGIUM', display: 'Belgium', code: 'be'},
    {id: 'NETHERLANDS', display: 'The Netherlands', code: 'nl'},
    {id: 'GERMANY', display: 'Germany', code: 'de'},
    {id: 'UNITED_KINGDOM', display: 'United kingdom', code: 'de'},
    {id: 'FRANCE', display: 'France', code: 'fr'},
    {id: 'AUSTRIA', display: 'Austria', code: 'at'},
    {id: 'POLAND', display: 'Poland', code: 'pl'},
    {id: 'ITALY', display: 'Italy', code: 'it'},
    {id: 'SWITZERLAND', display: 'Switzerland', code: 'ch'},
    {id: 'SPAIN', display: 'Spain', code: 'es'},
    {id: 'NORTH_AMERICA', display: 'North America', code: 'na'},
    {id: 'OTHER_COUNTRIES', display: 'Other countries', code: 'si'},
    //Must be last in the list!!!
    {id: 'ALL_COUNTRIES', display: 'All', code: 'all'}
  ];

module.exports = exports;



// WEBPACK FOOTER //
// /src/components/Util/CountryList.js